/*
 * Copyright (c) 2019 AccelByte Inc. All Rights Reserved
 * This is licensed software from AccelByte Inc, for limitations
 * and restrictions contact your company contract manager.
 */

import * as React from "react";
import styles from "./ErrorContainer.module.scss";
import emptyDocument from "assets/images/document-empty.svg";

interface Props {
  title?: React.ReactNode;
  description: React.ReactNode;
  footer?: React.ReactNode;
}

export default class ErrorContainer extends React.Component<Props> {
  render() {
    const { title, description, footer } = this.props;
    return (
      <div className={styles.container}>
        <img alt="empty-document" className={styles.image} src={emptyDocument} />
        {!!title && <div className={styles.title}>{title}</div>}
        {!!description && <div className={styles.description}>{description}</div>}
        {!!footer && (
          <>
            <div className={styles.separator} />
            <div className={styles.footer}>{footer}</div>
          </>
        )}
      </div>
    );
  }
}
